module.exports = __webpack_public_path__ + "img/04_Wolke_iPad_P.e46e5430.jpg";